import { abilitiesPlugin } from '@casl/vue';
import numeral from 'numeral';

import selectable from '@/plugins/selectable';
import store from '@/store/index.js';
import bus from '@/utils/bus';
import * as dateUtils from '@/utils/date';

import ability from './ability';

export default (app) => {
  // Set properties that were previously in Vue.prototype to app.config.globalProperties
  // These properties are still accessible in components through `this.$bus`, `this.$date`, etc.
  app.config.globalProperties.$bus = bus;
  app.config.globalProperties.$date = dateUtils;
  app.config.globalProperties.$numeral = numeral;
  // Use plugins with the app instance

  app.use(abilitiesPlugin, ability.defineAbilities(), {
    useGlobalProperties: true, // Add this option to enable global properties like $ability and $can
  });
  app.use(selectable);

  /**
   * Checks if the user has the given permission for an action on a subject.
   *
   * @param {string} action - The action to check (e.g., 'view').
   * @param {string} subject - The subject of the action (e.g., 'user').
   * @returns {boolean} - True if the user has permission, otherwise false.
   *
   * @example
   * // Check if the user has permission to edit banner custom content
   * this.$c('edit', 'bannerCustomContent'); // returns true or false
   */
  app.config.globalProperties.$c = function (action, subject) {
    for (let i = 0; i < store.getters.userGrants.length; i++) {
      let el = store.getters.userGrants[i];
      let [subj, act] = el.actionName.split('.');
      if (subject === subj && act === action) {
        return true;
      }
    }
    return false;
  };
};
